export default __webpack_public_path__ + "static/media/reading.bdc77490.png";